/** KAI */
export const KEYWORDS_PER_TRY = 10;
